<template>
  <div v-if="this.$store.state.isMobile" class="agenda-tab flex">
    <div
      class="tab-box flex align-center justify-center cs"
      style="display: flex"
      :class="{ active: index === tabIndex }"
      v-for="(item, index) in typeList"
      :key="index"
      @click="tabIndexChange(index, item.type)"
    >
      <div class="title flex flex-direction">
        {{ item.type }}
      </div>
      <div v-if="index > 0" class="obliqueShadow"></div>
    </div>
  </div>
  <div v-else class="agenda-tab flex flex-direction">
    <div class="theme-tab" v-show="tabIndex == 0 && dateIndex == 0">
      <div class="theme-box">
        <div class="type flex align-center justify-center">主题演讲</div>
        <div class="date-tab flex cs">
          <div
            class="date-box1 flex align-center justify-center cs"
            :class="{ 'date-box-hover': currentIndex == 0 }"
            @click="themeIndexChange(0)"
          >
            <div class="date">
              {{ typeList[0].list[0].startTime | timefilter }}-{{
                typeList[0].list[0].endTime | timefilter
              }}
            </div>
            <div class="red-line"></div>
            <div class="hover-bg"></div>
          </div>
          <div class="x-bg"></div>
          <div
            class="date-box2 flex align-center justify-center cs"
            :class="{ 'date-box-hover': currentIndex == 1 }"
            @click="themeIndexChange(1)"
          >
            <div class="date">
              {{ typeList[0].list[1].startTime | timefilter }}-{{
                typeList[0].list[1].endTime | timefilter
              }}
            </div>
            <div class="red-line"></div>
            <div class="hover-bg"></div>
          </div>
        </div>
      </div>
      <div class="special-box cs" @click="tabIndexChange(1, '论坛')">
        <div class="type flex align-center justify-center cs">论坛</div>
      </div>
      <div class="special-box cs" @click="tabIndexChange(2, '专场')">
        <div class="type flex align-center justify-center">专场</div>
      </div>
      <img :src="themeBg" class="bgImg" alt="" />
    </div>
    <div class="special-tab" v-show="tabIndex == 1 && dateIndex == 0">
      <div class="theme-box cs" @click="tabIndexChange(0, '主题演讲')">
        <div class="type flex align-center justify-center cs">主题演讲</div>
      </div>
      <div
        class="special-box special-box-hover flex flex-direction align-center justify-center"
      >
        <div class="type flex align-center justify-center">论坛</div>
        <div class="date">
          {{ typeList[tabIndex].list[0].startTime | timefilter }} -
          {{
            typeList[tabIndex].list[typeList[tabIndex].list.length - 1].endTime
              | timefilter
          }}
        </div>
      </div>
      <div
        class="special-box flex flex-direction align-center justify-center cs"
        @click="tabIndexChange(2, '专场')"
      >
        <div class="type flex align-center justify-center">专场</div>
      </div>
      <img :src="specialBg1" class="bgImg" alt="" />
    </div>
    <div class="special-tab2" v-show="tabIndex == 2 && dateIndex == 0">
      <div class="theme-box cs" @click="tabIndexChange(0, '主题演讲')">
        <div class="type flex align-center justify-center cs">主题演讲</div>
      </div>
      <div
        class="special-box flex flex-direction align-center justify-center cs"
        @click="tabIndexChange(1, '论坛')"
      >
        <div class="type flex align-center justify-center">论坛</div>
      </div>
      <div
        class="special-box special-box-hover flex flex-direction align-center justify-center"
      >
        <div class="type flex align-center justify-center">专场</div>
        <div class="date">
          {{ typeList[tabIndex].list[0].startTime | timefilter }} -
          {{
            typeList[tabIndex].list[typeList[tabIndex].list.length - 1].endTime
              | timefilter
          }}
        </div>
      </div>
      <img :src="specialBg2" class="bgImg" alt="" />
    </div>
    <div class="special-tab-big" v-show="(tabIndex == 0) & (dateIndex == 1)">
      <div
        class="special-box special-box-hover flex flex-direction align-center justify-center"
      >
        <div class="type flex align-center justify-center">论坛</div>
        <div class="date">
          {{ typeList[tabIndex].list[0].startTime | timefilter }} -
          {{
            typeList[tabIndex].list[typeList[tabIndex].list.length - 1].endTime
              | timefilter
          }}
        </div>
      </div>
      <div
        class="special-box flex flex-direction align-center justify-center cs"
        @click="tabIndexChange(1, '专场')"
      >
        <div class="type flex align-center justify-center">专场</div>
      </div>
      <img :src="specialBgBiG1" class="bgImg" alt="" />
    </div>
    <div class="special-tab2-big" v-show="tabIndex == 1 && dateIndex == 1">
      <div
        class="special-box flex flex-direction align-center justify-center cs"
        @click="tabIndexChange(0, '论坛')"
      >
        <div class="type flex align-center justify-center">论坛</div>
      </div>
      <div
        class="special-box special-box-hover flex flex-direction align-center justify-center"
      >
        <div class="type flex align-center justify-center">专场</div>
        <div class="date">
          {{ typeList[tabIndex].list[0].startTime | timefilter }} -
          {{
            typeList[tabIndex].list[typeList[tabIndex].list.length - 1].endTime
              | timefilter
          }}
        </div>
      </div>
      <img :src="specialBgBiG2" class="bgImg" alt="" />
    </div>
    <!--    <div class="name">-->
    <!--      {{ item.type }}-->
    <!--    </div>-->
    <!--    <div class="date">-->
    <!--      <div class="text">-->
    <!--        {{ item.date }}-->
    <!--      </div>-->
    <!--      <div class="line"></div>-->
    <!--    </div>-->
    <!--    <div-->
    <!--      class="tab-box flex align-center justify-end cs"-->
    <!--      v-for="(item, index) in typeList"-->
    <!--      :key="index"-->
    <!--      @click="tabIndexChange(index)"-->
    <!--      :class="{ active: index === tabIndex }"-->
    <!--    >-->
    <!--    </div>-->
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "typeTab",
  props: {
    //列表
    typeList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    dateIndex: {
      type: Number,
      default: function () {
        return 0;
      },
    },
  },
  filters: {
    timefilter(timestamp) {
      return dayjs(timestamp * 1000).format("HH:mm");
    },
  },
  data() {
    return {
      tabIndex: 0,
      currentIndex: 0,
      nowIndex: 0,
      themeBg: require("../../assets/images/agenda/home/theme-bg.png"),
      specialBg1: require("../../assets/images/agenda/home/special-bg1.png"),
      specialBg2: require("../../assets/images/agenda/home/special-bg2.png"),
      specialBgBiG1: require("../../assets/images/agenda/home/bigspecial-bg1.png"),
      specialBgBiG2: require("../../assets/images/agenda/home/bigspecial-bg2.png"),
    };
  },
  methods: {
    tabIndexChange(idx, type) {
      if (idx == 0) {
        this.currentIndex = 0;
      }
      //埋码
      window._hw("send", "action", "index_agenda_module_click");
      this.tabIndex = idx;
      this.$emit("typeChange", { idx, type });
      this.nowIndex = idx;
    },
    themeIndexChange(idx) {
      this.currentIndex = idx;
      this.$emit("themeIndexChange", idx);
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 992px) {
  .agenda-tab {
    width: 314px;
    height: 100%;
    z-index: 2;
    .theme-tab {
      width: 100%;
      height: 100%;
      position: relative;
      //background-image: url("../../assets/images/agenda/home/theme-bg.png");
      //background-repeat: no-repeat;
      //background-position: 0 0;
      //background-size: 314px 602px;
      .bgImg {
        position: absolute;
        top: 0;
        left: 0;
        width: 314px;
        height: 602px;
        z-index: 0;
      }
      .theme-box {
        width: 296px;
        height: 241px;
        z-index: 1;
        position: relative;
        .type {
          height: 169px;
          font-size: 32px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: bold;
          color: #151e26;
          line-height: 46px;
        }
        .date-tab {
          width: 100%;
          height: 69px;
          position: relative;
          .x-bg {
            position: absolute;
            left: 140px;
            top: 0;
            width: 77px;
            height: 69px;
            background-image: url("../../assets/images/agenda/home/x-bg.png");
            background-repeat: no-repeat;
            background-position: 0 0;
            background-size: 77px 69px;
          }
          .date-box1 {
            width: 160px;
            height: 70px;
            position: relative;

            .date {
              font-size: 18px;
              font-family: Microsoft YaHei-Bold, Microsoft YaHei;
              font-weight: bold;
              color: #828282;
            }
            .red-line {
              display: none;
            }
            .hover-bg {
              display: none;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-image: url("../../assets/images/agenda/home/left-hover.png");
              background-repeat: no-repeat;
              background-position: 0 0;
              background-size: 160px 70px;
            }
          }
          .date-box2 {
            width: 160px;
            height: 70px;
            position: relative;
            .date {
              font-size: 18px;
              font-family: Microsoft YaHei-Bold, Microsoft YaHei;
              font-weight: bold;
              color: #828282;
            }
            .red-line {
              display: none;
            }
            .hover-bg {
              display: none;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-image: url("../../assets/images/agenda/home/right-hover.png");
              background-repeat: no-repeat;
              background-position: 0 0;
              background-size: 160px 70px;
            }
          }
          .date-box-hover {
            .date {
              color: #b4251e;
            }
            .red-line {
              display: block;
              position: absolute;
              bottom: 0;
              left: calc(50% - 39px);
              width: 78px;
              height: 4px;
              background: #b4251e;
              opacity: 1;
            }
            .hover-bg {
              display: block;
            }
          }
        }
      }
      .special-box {
        flex: 1;
        z-index: 1;
        position: relative;
        .type {
          height: 179px;
          width: 296px;
          font-size: 32px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: bold;
          color: #151e26;
          line-height: 46px;
        }
      }
      .theme-bg {
        width: 314px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-image: url("../../assets/images/agenda/home/theme-bg.png");
        background-repeat: no-repeat;
        background-position: 0 0;
        background-size: 314px 602px;
        z-index: 0;
      }
    }
    .special-tab {
      width: 100%;
      height: 100%;
      position: relative;
      //background-image: url("../../assets/images/agenda/home/special-bg1.png");
      //background-repeat: no-repeat;
      //background-position: 0 0;
      //background-size: 314px 602px;
      .bgImg {
        position: absolute;
        top: 0;
        left: 0;
        width: 314px;
        height: 602px;
        z-index: 0;
      }
      .theme-box {
        height: 200px;
        width: 296px;
        z-index: 1;
        position: relative;
        .type {
          height: 100%;
          font-size: 32px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: bold;
          color: #151e26;
          line-height: 46px;
        }
      }
      .special-box {
        height: 200px;
        width: 296px;
        z-index: 1;
        position: relative;
        .type {
          font-size: 32px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: bold;
          color: #151e26;
          line-height: 46px;
        }
        .date {
          display: none;
          margin-top: 14px;
          font-size: 18px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: bold;
          color: #b4251e;
        }
      }
      .special-box-hover {
        .type {
          color: #b4251e;
        }
        .date {
          display: block;
          color: #b4251e;
        }
      }
    }
    .special-tab2 {
      width: 100%;
      height: 100%;
      position: relative;
      //background-image: url("../../assets/images/agenda/home/special-bg2.png");
      //background-repeat: no-repeat;
      //background-position: 0 0;
      //background-size: 314px 602px;
      .bgImg {
        position: absolute;
        top: 0;
        left: 0;
        width: 314px;
        height: 602px;
        z-index: 0;
      }
      .theme-box {
        height: 200px;
        width: 296px;
        z-index: 1;
        position: relative;
        .type {
          z-index: 1;
          height: 100%;
          font-size: 32px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: bold;
          color: #151e26;
          line-height: 46px;
        }
      }
      .special-box {
        height: 200px;
        width: 296px;
        z-index: 1;
        position: relative;
        .type {
          z-index: 1;
          font-size: 32px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: bold;
          color: #151e26;
          line-height: 46px;
        }
        .date {
          z-index: 1;
          display: none;
          margin-top: 14px;
          font-size: 18px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: bold;
          color: #b4251e;
        }
      }
      .special-box-hover {
        .type {
          color: #b4251e;
        }
        .date {
          display: block;
          color: #b4251e;
        }
      }
    }

    .special-tab-big {
      width: 100%;
      height: 100%;
      position: relative;
      //background-image: url("../../assets/images/agenda/home/bigspecial-bg1.png");
      //background-repeat: no-repeat;
      //background-position: 0 0;
      //background-size: 314px 602px;
      .bgImg {
        position: absolute;
        top: 0;
        left: 0;
        width: 314px;
        height: 602px;
        z-index: 0;
      }

      .special-box {
        height: 50%;
        width: 296px;
        z-index: 1;
        position: relative;
        .type {
          font-size: 32px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: bold;
          color: #151e26;
          line-height: 46px;
        }
        .date {
          display: none;
          margin-top: 14px;
          font-size: 18px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: bold;
          color: #b4251e;
        }
      }
      .special-box-hover {
        .type {
          color: #b4251e;
        }
        .date {
          display: block;
          color: #b4251e;
        }
      }
    }
    .special-tab2-big {
      width: 100%;
      height: 100%;
      position: relative;
      //background-image: url("../../assets/images/agenda/home/bigspecial-bg2.png");
      //background-repeat: no-repeat;
      //background-position: 0 0;
      //background-size: 314px 602px;
      .bgImg {
        position: absolute;
        top: 0;
        left: 0;
        width: 314px;
        height: 602px;
        z-index: 0;
      }
      .special-box {
        position: relative;
        z-index: 1;
        height: 50%;
        width: 296px;
        .type {
          font-size: 32px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: bold;
          color: #151e26;
          line-height: 46px;
        }
        .date {
          display: none;
          margin-top: 14px;
          font-size: 18px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: bold;
          color: #b4251e;
        }
      }
      .special-box-hover {
        .type {
          color: #b4251e;
        }
        .date {
          display: block;
          color: #b4251e;
        }
      }
    }
    .tab-box {
      width: 100%;
      height: 128px;
      padding-right: 48px;

      .name {
        height: 46px;
        font-size: 32px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: bold;
        color: #828282;
      }
      .date {
        width: auto;
        margin-left: 16px;
        .text {
          font-size: 16px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #828282;
        }
        .line {
          width: auto;
          height: 4px;
          margin-top: 14px;
          margin-bottom: 10px;
          background: #b2bfc6;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
        }
      }
    }
    .active {
      .name {
        color: #b4251e;
      }
      .date {
        .line {
          background: #b4251e;
        }
      }
    }
  }
}
@media (max-width: 992px) {
  .agenda-tab {
    z-index: 2;
    width: calc(100vw - 70px);
    height: 104px;
    white-space: nowrap;
    overflow-x: scroll; /*x轴禁止滚动*/
    overflow-y: hidden; /*y轴滚动*/
    background: linear-gradient(
      322deg,
      #ffffff 0%,
      rgba(255, 255, 255, 0.35) 100%
    );
    border: none;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    box-sizing: border-box;
    .tab-box {
      width: 50%;
      height: 104px;
      display: inline-block;
      vertical-align: top;
      position: relative;
      box-sizing: inherit;

      .title {
        width: auto;
        color: #999999;
        font-size: 28px;
        margin: 0 8px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;
        text-align: center;
        line-height: 104px;
      }
      .mark {
        margin-top: 20px;
        font-size: 16px;
        font-family: Microsoft YaHei-Light, Microsoft YaHei;
        font-weight: 400;
        padding: 3px 4px;
        border-radius: 0 0 10px 0;
        border: 1px solid #aaaaaa;
        color: #aaaaaa;
        align-self: flex-start;
        line-height: 1;
      }
      .obliqueShadow {
        width: 114px;
        height: 104px;
        z-index: 0;
        position: absolute;
        top: 0;
        left: -10px;
        background-image: url("../../assets/images/agenda/obliqueShadow.png");
        background-repeat: no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;
      }
    }
    .tab-box:hover {
      background-image: url("../../assets/images/agenda/redbg.png");
      background-repeat: no-repeat;
      background-position: 0 0;
      background-size: 100% 100%;
    }
    .active {
      height: 100%;
      background-image: url("../../assets/images/agenda/redbg.png");
      background-repeat: no-repeat;
      background-position: 0 0;
      background-size: 100% 100%;
      border: none;
      display: flex;
      .title {
        color: #b4251e;
        font-size: 28px;
        box-sizing: inherit;
        font-family: Microsoft YaHei-Light;
        font-weight: 600;
        text-align: center;
        line-height: 100px;
        border-bottom: 4px solid #b4251e;
      }
      .mark {
        margin-top: 20px;
        font-size: 16px;
        font-weight: 300;
        padding: 3px 4px;
        border-radius: 0 0 10px 0;
        border: 1px solid #b4251e;
        color: #b4251e;
        align-self: flex-start;
        line-height: 1;
      }
    }
  }
  //.agenda-tab::-webkit-scrollbar {
  //  display: none; /*隐藏滚动条*/
  //}
}
</style>
